import { cn } from 'lib/helpers/utility';

const PayOnlineButton = ({ className = 'self-end' }) => {
  return (
    <div className={cn('payment-button-submit-wrapper flex items-center', className)}>
      <div className="card-submit submit-button payroc-card-submit-button h-8" />
    </div>
  );
};

export default PayOnlineButton;
